
export const initialState = {
    releasenotes: {
        activeTab: "1",
        searchText: "",
        releasenotesList: [],        
    }
}